import { Style } from '@/components/style';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import StoreUtils from '@/utils/storeInfoUtils';
import moment from 'moment';
import { forEach, head, last, uniqueId, isEmpty, cloneDeep } from 'lodash';
import OrderServeType from '@/constants/OrderServeType';
import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import { TimeSelector } from '@/components/welcome/components';
import usePreorderTimeValidator from '@/components/customizeWelcome/hooks/usePreordertimeValidator';
import {
  setWelcomeSelectedDatePreorderTime,
  setWelcomeSelectedTimePreorderTime,
} from '@/actions/customizeWelcome/customizeWelcomeAction';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import PreorderDateSelector from '@/ui/PreorderDateSelector';
import PreorderTimeSelector from '@/ui/PreorderTimeSelector';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

function WelcomePreordertimeSelector({
  webStoreVo,
  selectedServeType,
  selectedTakeOutServeType,
  setSelectedTakeOutServeType,
}) {
  const dispatch = useDispatch();
  // const { isValid: isPreorderTimeValid } = usePreorderTimeValidator(
  //   webStoreVo,
  //   orderVo
  // );
  const isPreorderTimeValid = useSelector<RootStateOrAny, any>(
    (state) => state.customizeWelcomeReducer.isSelectedPreorderTimeValid
  );
  const [minDate, setMinDate] = useState<Date>();
  const [maxDate, setMaxDate] = useState<Date>();
  const [excludeDates, setExcludeDates] = useState<Date[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>();
  const [availableTimes, setAvailableTimes] = useState<string[]>([]);
  const [selectedTime, setSelectedTime] = useState<string | undefined>();
  const [timeInfos, setTimeInfos] = useState<any[]>([]);

  useEffect(() => {
    if (selectedDate) {
      dispatch(setWelcomeSelectedDatePreorderTime(selectedDate));
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedTime) {
      dispatch(setWelcomeSelectedTimePreorderTime(selectedTime));
    }
  }, [selectedTime]);

  // 這裡是複製原本 welcome 的，需 refactor
  useEffect(() => {
    if (webStoreVo && selectedServeType !== OrderServeType.DEFAULT) {
      setSelectedDate(undefined);
      setSelectedTime(undefined);
      setExcludeDates([]);

      const { preorderTimeMap } = webStoreVo;
      const serveAvailableDates =
        preorderTimeMap[selectedServeType]?.availableDates;

      if (selectedServeType === 'DELIVERY' && serveAvailableDates.length > 0) {
        const minDateString = head(serveAvailableDates) || null;
        setMinDate(moment(minDateString, 'YYYY-MM-DD').toDate());

        const maxDateString = last(serveAvailableDates) || null;
        setMaxDate(moment(maxDateString, 'YYYY-MM-DD').toDate());

        let current;
        const newExcludeDates: Date[] = [];

        forEach(serveAvailableDates, (availableDate) => {
          if (current == null) {
            current = moment(availableDate).format('YYYY-MM-DD');
          }
          const da: any = moment(availableDate).format('YYYY-MM-DD');
          while (current !== da) {
            newExcludeDates.push(new Date(current));
            current = moment(moment(current).add(1, 'd')).format('YYYY-MM-DD');
          }
          current = moment(moment(current).add(1, 'd')).format('YYYY-MM-DD');
        });

        setExcludeDates(newExcludeDates);

        let selected = false;

        forEach(serveAvailableDates, (availableDate): boolean => {
          if (selected) {
            return false;
          }

          const selectDateString = availableDate;

          setSelectedDate(moment(selectDateString, 'YYYY-MM-DD').toDate());

          let selectedKey;
          Object.keys(preorderTimeMap[selectedServeType].availableTimes).some(
            (key) => {
              if (key.includes(moment(selectDateString).format('yyyy-MM-DD'))) {
                selectedKey = key;
                return true;
              }
              return false;
            }
          );

          setAvailableTimes([]);
          setTimeInfos([]);
          let times: any = [];
          let newTimeInfos: any = [];
          preorderTimeMap[selectedServeType].availableTimes[
            selectedKey
          ].forEach((time) => {
            times = [...times, time];
            setAvailableTimes((availableTime) => [...availableTime, time]);
          });

          preorderTimeMap[selectedServeType].timeInfos[selectedKey]?.forEach(
            (info) => {
              newTimeInfos = [...newTimeInfos, info];
              setTimeInfos((oldTimeInfos) => [...oldTimeInfos, info]);
            }
          );

          forEach(times, (time) => {
            let timeInfo;
            newTimeInfos.some((info) => {
              if (info.time === time) {
                timeInfo = info;
                return true;
              }
              return false;
            });

            const disabled: any = timeInfo?.full ? 'disabled' : undefined;
            if (disabled === undefined) {
              selected = true;
              setSelectedTime(time);
              return false;
            }
            return true;
          });

          return true;
        });
      }

      const takeOutServeAvailableDates =
        preorderTimeMap[selectedTakeOutServeType]?.availableDates;

      if (webStoreVo.availableTakeOutServeTypes?.length === 1) {
        setSelectedTakeOutServeType(webStoreVo.availableTakeOutServeTypes[0]);
      }

      if (
        selectedServeType === 'TAKE_OUT' &&
        selectedTakeOutServeType === 'SCHEDULE_TAKE_OUT' &&
        takeOutServeAvailableDates.length > 0
      ) {
        const minDateString = head(takeOutServeAvailableDates) || null;
        setMinDate(moment(minDateString, 'YYYY-MM-DD').toDate());

        const maxDateString = last(takeOutServeAvailableDates) || null;

        setMaxDate(moment(maxDateString, 'YYYY-MM-DD').toDate());

        let current;
        const newExcludeDates: Date[] = [];

        forEach(takeOutServeAvailableDates, (availableDate) => {
          if (current == null) {
            current = moment(availableDate).format('YYYY-MM-DD');
          }
          const da: any = moment(availableDate).format('YYYY-MM-DD');
          while (current !== da) {
            newExcludeDates.push(new Date(current));
            current = moment(moment(current).add(1, 'd')).format('YYYY-MM-DD');
          }
          current = moment(moment(current).add(1, 'd')).format('YYYY-MM-DD');
        });

        setExcludeDates(newExcludeDates);

        let selected = false;
        forEach(takeOutServeAvailableDates, (availableDate) => {
          if (selected) {
            return false;
          }

          const selectedDateString = availableDate;
          setSelectedDate(moment(selectedDateString, 'YYYY-MM-DD').toDate());

          let selectedKey;
          Object.keys(
            preorderTimeMap[selectedTakeOutServeType].availableTimes
          ).some((key) => {
            if (key.includes(moment(selectedDateString).format('yyyy-MM-DD'))) {
              selectedKey = key;
              return true;
            }
            return false;
          });
          setAvailableTimes([]);
          setTimeInfos([]);

          let times: any = [];
          let newTimeInfos: any = [];
          preorderTimeMap[selectedTakeOutServeType].availableTimes[
            selectedKey
          ].forEach((time) => {
            times = [...times, time];
            setAvailableTimes((availableTime) => [...availableTime, time]);
          });

          preorderTimeMap[selectedTakeOutServeType].timeInfos[
            selectedKey
          ]?.forEach((info) => {
            newTimeInfos = [...newTimeInfos, info];
            setTimeInfos((oldTimeInfos) => [...oldTimeInfos, info]);
          });

          forEach(times, (time) => {
            let timeInfo;
            newTimeInfos.some((info) => {
              if (info.time === time) {
                timeInfo = info;
                return true;
              }
              return false;
            });

            const disabled: any = timeInfo?.full ? 'disabled' : undefined;
            if (disabled === undefined) {
              selected = true;
              setSelectedTime(time);
              return false;
            }

            return true;
          });

          return true;
        });
      }
    }

    if (document.querySelector('.react-datepicker__input-container > input')) {
      const a: any = document.querySelector(
        '.react-datepicker__input-container > input'
      );
      a.setAttribute('readonly', 'readonly');
      a.setAttribute('data-testid', 'date');
    }

    return () => {};
  }, [webStoreVo, selectedServeType, selectedTakeOutServeType]);

  const onChangeSelectedDate = (date) => {
    if (date) {
      setSelectedDate(date);
      let serveType =
        selectedServeType === 'DELIVERY' ? 'DELIVERY' : 'SCHEDULE_TAKE_OUT';
      let selectedKey: string = '';
      Object.keys(webStoreVo.preorderTimeMap[serveType].availableTimes).some(
        (key) => {
          if (key.includes(moment(date).format('yyyy-MM-DD'))) {
            selectedKey = key;
            return true;
          }
          return false;
        }
      );
      let tempAvaliableTimes: any = [];
      let tempTimeInfos: any = [];
      webStoreVo.preorderTimeMap[serveType].availableTimes[
        selectedKey
      ]?.forEach((time) => {
        tempAvaliableTimes.push(time);
        // setAvailableTimes((availableTime) => [...availableTime, time]);
      });
      webStoreVo.preorderTimeMap[serveType].timeInfos[selectedKey]?.forEach(
        (info) => {
          tempTimeInfos.push(info);
          // setTimeInfos((timeInfos) => [...timeInfos, info]);
        }
      );
      setAvailableTimes(tempAvaliableTimes);
      setTimeInfos(tempTimeInfos);
      setSelectedTime(undefined);
    }
  };

  return (
    <div>
      {selectedServeType === 'DELIVERY' ||
      (selectedServeType === 'TAKE_OUT' &&
        selectedTakeOutServeType === 'SCHEDULE_TAKE_OUT') ? (
        <div className="d-flex justify-content-between">
          <div style={{ width: '49%' }}>
            <PreorderDateSelector
              value={selectedDate}
              onChange={onChangeSelectedDate}
              maxDate={maxDate}
              minDate={minDate}
            />
          </div>
          <div style={{ width: '49%' }}>
            <PreorderTimeSelector
              value={selectedTime}
              availableTimes={availableTimes}
              timeInfos={timeInfos}
              setSelectedTime={setSelectedTime}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      {!isPreorderTimeValid &&
      (selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT ||
        selectedServeType === OrderServeType.DELIVERY ||
        selectedServeType === OrderServeType.PICK_UP) ? (
        <div
          className="d-flex"
          style={{ color: alertColor, margin: '5px 0px 10px 0px' }}
        >
          <Warn style={{ marginRight: '5px' }} />
          <div style={{ fontSize: '12px' }}>
            <FormattedMessage id="error.preorderTime" />
          </div>
        </div>
      ) : (
        (selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT ||
          selectedServeType === OrderServeType.DELIVERY ||
          selectedServeType === OrderServeType.PICK_UP) && (
          <div style={{ marginBottom: '10px' }} />
        )
      )}
    </div>
  );
}

WelcomePreordertimeSelector.defaultProps = {};

WelcomePreordertimeSelector.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
  selectedServeType: PropTypes.string.isRequired,
  selectedTakeOutServeType: PropTypes.string.isRequired,
  setSelectedTakeOutServeType: PropTypes.func.isRequired,
};

export default WelcomePreordertimeSelector;
